"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Zeppelins = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const Resources_1 = require("../../Resources");
const CardName_1 = require("../../CardName");
const CardRequirements_1 = require("../CardRequirements");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
class Zeppelins extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.ZEPPELINS,
            cost: 13,
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.oxygen(5)),
            metadata: {
                cardNumber: '129',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.production((pb) => {
                        pb.megacredits(1).slash();
                        pb.city(Size_1.Size.SMALL).any.asterix();
                    });
                }),
                description: 'Requires 5% oxygen. Increase your M€ production 1 step for each City tile ON MARS.',
                victoryPoints: 1,
            },
        });
    }
    play(player) {
        player.addProduction(Resources_1.Resources.MEGACREDITS, player.game.getCitiesInPlayOnMars(), { log: true });
        return undefined;
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.Zeppelins = Zeppelins;
//# sourceMappingURL=Zeppelins.js.map